<template>
  <div
    class="
      max-w-5xl
      p-6
      mx-auto
      static
      top-0
      left-72
      right-0
      z-50
      mt-20
      rounded-md
      shadow-md
      modal-box
      mb-20
      border-2 border-blue-600
    "
  >
    <div
      class="cursor-pointer absolute right-5 top-2"
      @click="profileCloseModal"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6 cursor-pointer"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    </div>
    <div class="overflow-y-auto relative">
      <h1 class="text-2xl font-bold text-theme-black capitalize">
        <span>Mill Profile</span>
      </h1>
      <div class="flex items-center justify-center h-52" v-if="loading">
        <img src="../../assets/830.svg" alt="loader" />
      </div>
      <div v-else class="p-2 grid grid-cols-3 gap-5 w-full">
        <div class="form-control">
          <label class="label">
            <span class="label-text font-bold tracking-wide">Mill Name</span>
          </label>
          <div class="relative flex items-center">
            <div class="absolute border-r-2 border-blue-400 py-1 px-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"
                />
              </svg>
            </div>

            <input
              v-model="millName"
              type="text"
              placeholder="Mill Name"
              class="input input-bordered w-full pl-12 focusring input-sm"
            />
          </div>
        </div>
        <div class="form-control">
          <label class="label">
            <span class="label-text font-bold tracking-wide">Address 1</span>
          </label>
          <div class="relative flex items-center">
            <div class="absolute border-r-2 border-blue-400 py-1 px-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                />
              </svg>
            </div>

            <input
              v-model="address1"
              type="text"
              placeholder="Address Line 1"
              class="input input-bordered w-full pl-12 focusring input-sm"
            />
          </div>
        </div>
        <div class="form-control">
          <label class="label">
            <span class="label-text font-bold tracking-wide">Address 2</span>
          </label>
          <div class="relative flex items-center">
            <div class="absolute border-r-2 border-blue-400 py-1 px-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                />
              </svg>
            </div>

            <input
              v-model="address2"
              type="text"
              placeholder="Address Line 2"
              class="input input-bordered w-full pl-12 focusring input-sm"
            />
          </div>
        </div>
        <div class="form-control">
          <label class="label">
            <span class="label-text font-bold tracking-wide">Address 3</span>
          </label>
          <div class="relative flex items-center">
            <div class="absolute border-r-2 border-blue-400 py-1 px-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                />
              </svg>
            </div>

            <input
              v-model="address3"
              type="text"
              placeholder="Address Line 3"
              class="input input-bordered w-full pl-12 focusring input-sm"
            />
          </div>
        </div>
        <div class="form-control">
          <label class="label">
            <span class="label-text font-bold tracking-wide">City</span>
          </label>
          <div class="relative flex items-center">
            <div class="absolute border-r-2 border-blue-400 py-1 px-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"
                />
              </svg>
            </div>

            <input
              v-model="city"
              type="text"
              placeholder="City"
              class="input input-bordered w-full pl-12 focusring input-sm"
            />
          </div>
        </div>
        <div class="form-control">
          <label class="label">
            <span class="label-text font-bold tracking-wide">State</span>
          </label>
          <div class="relative flex items-center">
            <div class="absolute border-r-2 border-blue-400 py-1 px-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"
                />
              </svg>
            </div>

            <input
              v-model="mState"
              type="text"
              placeholder="State"
              class="input input-bordered w-full pl-12 focusring input-sm"
            />
          </div>
        </div>
        <div class="form-control">
          <label class="label">
            <span class="label-text font-bold tracking-wide">Pincode</span>
          </label>
          <div class="relative flex items-center">
            <div class="absolute border-r-2 border-blue-00 py-1 px-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            </div>

            <input
              v-model="pincode"
              type="text"
              placeholder="Pincode"
              class="input input-bordered w-full pl-12 focusring input-sm"
            />
          </div>
        </div>
        <div class="form-control">
          <label class="label">
            <span class="label-text font-bold tracking-wide"
              >Installed Spindles</span
            >
          </label>
          <div class="relative flex items-center">
            <div class="absolute border-r-2 border-blue-400 py-1 px-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
                />
              </svg>
            </div>

            <input
              v-model="installedSpdls"
              type="number"
              placeholder="Spindles"
              class="input input-bordered w-full pl-12 focusring input-sm"
            />
          </div>
        </div>
        <div class="form-control">
          <label class="label">
            <span class="label-text font-bold tracking-wide"
              >Installed Rotors</span
            >
          </label>
          <div class="relative flex items-center">
            <div class="absolute border-r-2 border-blue-400 py-1 px-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
                />
              </svg>
            </div>

            <input
              v-model="installedRotors"
              type="number"
              placeholder="Rotors"
              class="input input-bordered w-full pl-12 focusring input-sm"
            />
          </div>
        </div>
        <div class="form-control">
          <label class="label">
            <span class="label-text font-bold tracking-wide"
              >Installed S Looms</span
            >
          </label>
          <div class="relative flex items-center">
            <div class="absolute border-r-2 border-blue-400 py-1 px-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
                />
              </svg>
            </div>

            <input
              v-model="installedSLooms"
              type="number"
              placeholder="S-Looms"
              class="input input-bordered w-full pl-12 focusring input-sm"
            />
          </div>
        </div>
        <div class="form-control">
          <label class="label">
            <span class="label-text font-bold tracking-wide"
              >Installed SL Looms</span
            >
          </label>
          <div class="relative flex items-center">
            <div class="absolute border-r-2 border-blue-400 py-1 px-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
                />
              </svg>
            </div>

            <input
              v-model="installedSlLooms"
              type="number"
              placeholder="SI-Looms"
              class="input input-bordered w-full pl-12 focusring input-sm"
            />
          </div>
        </div>
        <div class="form-control">
          <label class="label">
            <span class="label-text font-bold tracking-wide">Gst Number</span>
          </label>
          <div class="relative flex items-center">
            <div class="absolute border-r-2 border-blue-400 py-1 px-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"
                />
              </svg>
            </div>

            <input
              v-model="gstNo"
              type="text"
              placeholder="GST Number"
              class="input input-bordered w-full pl-12 focusring input-sm"
            />
          </div>
        </div>
        <div class="col-start-4 flex justify-end mt-10">
          <button
            :disabled="clicked"
            @click="updateData"
            v-if="dataExists"
            class="
              px-6
              py-2
              font-bold
              tracking-wide
              transition-colors
              duration-200
              transform
              bg-blue-500
              text-blue-100
              rounded-xl
              hover:bg-blue-600 hover:text-blue-300
              focus:outline-none focus:bg-blue-600
            "
          >
            Update
          </button>
          <button
            :disabled="clicked"
            @click="profileData"
            v-else
            type="submit"
            class="
              px-6
              py-2
              font-bold
              tracking-wide
              transition-colors
              duration-200
              transform
              bg-blue-500
              text-blue-100
              rounded-xl
              hover:bg-blue-600 hover:text-blue-300
              focus:outline-none focus:bg-blue-600
            "
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Profile",
  props: ["profileCloseModal"],
  data() {
    return {
      millName: "",
      clicked: false,
      address1: "",
      address2: "",
      address3: "no-data",
      city: "",
      mState: "",
      pincode: "",
      installedSpdls: Number(),
      installedRotors: Number(),
      installedSLooms: Number(),
      installedSlLooms: Number(),
      gstNo: "",
      dataExists: false,
      loading: false,
    };
  },
  created() {
    this.getMillData();
  },
  methods: {
    clearData() {
      this.millName = "";
      this.address1 = "";
      this.address2 = "";
      this.address3 = "";
      this.city = "";
      this.mState = "";
      this.pincode = "";
      this.installedSpdls = "";
      this.installedRotors = "";
      this.installedSLooms = "";
      this.installedSlLooms = "";
      this.gstNo = "";
      this.profileCloseModal();
    },
    profileData() {
      this.clicked = true;
      let data = JSON.stringify({
        regId: sessionStorage.getItem("millId"),
        millName: this.millName,
        address1: this.address1,
        address2: this.address2,
        address3: this.address3,
        city: this.city,
        state: this.mState,
        pincode: this.pincode,
        installedSpdls: this.installedSpdls,
        installedRotors: this.installedRotors,
        installedSlooms: this.installedSLooms,
        installedSLlooms: this.installedSlLooms,
        gstNo: this.gstNo,
      });
      axios
        .post(
          ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/MillProfile`,
          data
        )
        .then((res) => {
          if (res.data.data) {
            this.clearData();
            this.clicked = false;
          } else {
            this.clearData();
            alert("Error saving Data");
            this.clicked = false;
          }
        })
        .catch((err) => {
          if (err) {
            this.clearData();
            alert("Error Sending data");
            this.clicked = false;
          }
        });
    },
    getMillData() {
      this.loading = true;
      let jdata = JSON.stringify({
        regId: sessionStorage.getItem("millId"),
      });
      axios
        .post(
          ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/MillData`,
          jdata
        )
        .then((res) => {
          if (!res.data.data) {
            this.dataExists = false;
            this.loading = false;
          } else if (Object.keys(res.data.data).length != 0) {
            (this.millName = res.data.data.mill_name),
              (this.address1 = res.data.data.address1),
              (this.address2 = res.data.data.address2),
              (this.address3 = res.data.data.address3),
              (this.city = res.data.data.city),
              (this.mState = res.data.data.state),
              (this.pincode = res.data.data.pincode),
              (this.installedSpdls = res.data.data.installed_spdls),
              (this.installedRotors = res.data.data.installed_rotors),
              (this.installedSLooms = res.data.data.installed_s_looms),
              (this.installedSlLooms = res.data.data.installed_sl_looms),
              (this.gstNo = res.data.data.gstno);
            this.dataExists = true;
            this.loading = false;
          }
        })
        .catch((err) => {
          if (err) {
            this.loading = false;

            alert("Error Getting Data");
          }
        });
    },

    updateData() {
      this.clicked = true;
      let data = JSON.stringify({
        regId: sessionStorage.getItem("millId"),
        millName: this.millName,
        address1: this.address1,
        address2: this.address2,
        address3: this.address3,
        city: this.city,
        state: this.mState,
        pincode: this.pincode,
        installedSpdls: this.installedSpdls,
        installedRotors: this.installedRotors,
        installedSlooms: this.installedSLooms,
        installedSLlooms: this.installedSlLooms,
        gstno: this.gstNo,
      });
      axios
        .post(
          ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/UpdateMillData`,
          data
        )
        .then((res) => {
          if (res.data.data) {
            this.clearData();
            this.clicked = false;
          } else {
            this.clearData();
            alert("Error saving Data");
            this.clicked = false;
          }
        })
        .catch((err) => {
          if (err) {
            this.clearData();
            alert("Error Sending data");
            this.clicked = false;
          }
        });
    },
  },
};
</script>
